import React from 'react';

export const MedicineIcon = ({
  width = 20,
  height = 20,
  color = '#2E51CD',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.536 6.464a4.5 4.5 0 0 0-6.364 0L3.05 10.586a4.5 4.5 0 0 0 6.364 6.364l4.122-4.122a4.5 4.5 0 0 0 0-6.364ZM8.5 16.036a3 3 0 0 1-4.243-4.243L7.5 8.55l4.243 4.243-3.243 3.243Zm4.122-4.122L9.379 8.671l1.864-1.864a3 3 0 0 1 4.243 4.243l-2.864 2.864Z"
      fill={color}
    />
  </svg>
);
